import { render, staticRenderFns } from "./edit-promocode.vue?vue&type=template&id=553881e5&"
import script from "./edit-promocode.vue?vue&type=script&lang=js&"
export * from "./edit-promocode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports